import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Shared SEO component for Race377 pages.
 * Sets title, meta description, OG tags, canonical, and optional JSON-LD.
 */
export default function Seo({
  title,
  description,
  image,
  url,
  type = "website",
  jsonLd,
  noIndex = false,
}) {
  const siteName = "Race377";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — Motorsport News, Analysis & Opinion`;
  const desc =
    description ||
    "Race377 — independent motorsport journalism covering Formula 1, WEC, IMSA, GT racing, Formula E, IndyCar, NASCAR and the business of racing.";
  const canonical = url || (typeof window !== "undefined" ? window.location.href : "");
  const ogImage = image || "/og-default.jpg";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
